import { computed } from 'vue'
import { storeToRefs } from 'pinia'
import { useBoekhoudingStore } from '@/stores/useBoekhoudingStore'
import type { Boekstuk, Transaction, TransactionEntry, Relatie } from '@/types'

export function useBoekhouding() {
  const store = useBoekhoudingStore()
  const { transactions, relaties, splitRules, accounts, businessRules, sequences, fileHandle } = storeToRefs(store)
  
  // Flattened entries for backward compatibility in components
  const entries = computed<Boekstuk[]>(() => {
    return transactions.value.flatMap((t: Transaction) => t.entries.map((e: TransactionEntry) => {
      const relatie = relaties.value.find((r: Relatie) => r.id === e.relatieId)
      return {
        ...e,
        relatie: relatie ? relatie.naam : 'Onbekend',
        transaction_id: t.id,
        boekstuknr: t.boekstuknr,
        datum: t.datum,
        omschrijving: t.omschrijving
      }
    }))
  })

  return {
    accounts,
    relaties,
    transactions,
    entries,
    splitRules,
    businessRules,
    sequences,
    fileHandle,
    isLocked: store.isLocked,
    addTransaction: store.addTransaction,
    updateTransaction: store.updateTransaction,
    deleteTransaction: store.deleteTransaction,
    stornoTransaction: store.stornoTransaction,
    addRelatie: store.addRelatie,
    updateRelatie: store.updateRelatie,
    deleteRelatie: store.deleteRelatie,
    addSplitRule: store.addSplitRule,
    updateSplitRule: store.updateSplitRule,
    deleteSplitRule: store.deleteSplitRule,
    updateBusinessRules: store.updateBusinessRules,
    setData: store.setData,
    loadDemoData: store.loadDemoData,
  }
}
